{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "AppointmentCalendar",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "title",
    "highlight",
    "introHtml",
    "submitLabel",
    "daysPerView",
    "showChannelOptions"
  ],
  "properties": {
    "title": {
      "title": "Title",
      "type": "string",
      "maxLength": 120
    },
    "highlight": {
      "title": "Highlighted title part",
      "type": "string",
      "maxLength": 120
    },
    "introHtml": {
      "title": "Intro text",
      "type": "string",
      "maxLength": 4000,
      "x-ui": "richtext"
    },
    "noticeHtml": {
      "title": "Notice under the form (e.g. request is not a confirmation)",
      "type": "string",
      "maxLength": 2000,
      "x-ui": "richtext"
    },
    "submitLabel": {
      "title": "Submit button",
      "type": "string",
      "maxLength": 40
    },
    "daysPerView": {
      "title": "Days per calendar page",
      "type": "integer",
      "minimum": 3,
      "maximum": 14
    },
    "showChannelOptions": {
      "title": "Ask for notification channels",
      "type": "boolean",
      "x-ui": "switch"
    }
  }
}
